import { supabase } from '../../supabaseClient';
import reportError from '../error-handler/reportError';

async function supabaseChangePassword({ userId, newPassword }) {
  const { error } = await supabase.auth.updateUser({
    id: userId,
    password: newPassword,
  });

  if (error) {
    reportError({
      message: 'Error changing password',
      code: 'PasswordChange',
      name: error.message,
      error,
    });
    console.error('Error changing password:', error.message);
    return error;
  }
  console.log('Password changed successfully!');
  return {};
}

export { supabaseChangePassword };
